import axios from "axios";
import toast from "react-hot-toast";
import { logout } from "../modules/auth/services/authApi";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

axios.defaults.headers.post["Content-Type"] = "application/json";
axios.defaults.headers.put["Content-Type"] = "application/json";
axios.defaults.headers.post["Accept"] = "application/json";

const clearAuthData = () => {
  sessionStorage.removeItem("authUser"); 
  sessionStorage.removeItem("authAdmin"); 
  sessionStorage.removeItem("backupAdmin"); 
};
const removeAuthorization = () => { delete axios.defaults.headers.common["Authorization"]; };

const getAuthData = () => {
  const storedUser = sessionStorage.getItem("authUser");
  const storedAdmin = sessionStorage.getItem("authAdmin");

  return storedUser
    ? JSON.parse(storedUser)
    : storedAdmin
      ? JSON.parse(storedAdmin)
      : null;
};

const setAuthorization = (token) => {
  axios.defaults.headers.common["Authorization"] = "Bearer " + token;
};

const auth = getAuthData();
if (auth?.token) {
  setAuthorization(auth.token);
} else {
  delete axios.defaults.headers.common["Authorization"];
}


let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach(p => (error ? p.reject(error) : p.resolve(token)));
  failedQueue = [];
};
 

axios.interceptors.response.use(  
  (response) => response.data ? response.data : response,

  async (error) => {
    // console.log('error.response =>', error);
    const originalRequest = error.config;

    if (
      error.response?.status === 401 &&
      !originalRequest._retry &&
      !originalRequest.url.includes("/auth/login") &&
      !originalRequest.url.includes("/auth/refresh")
    ) {
      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        }).then(token => {
          originalRequest.headers.Authorization = "Bearer " + token;
          return axios(originalRequest);
        });
      }

      originalRequest._retry = true;
      isRefreshing = true;

      try {
        const authData = getAuthData();
        if (!authData?.refreshToken) throw error;

        const newData = await axios.post(
          `${process.env.REACT_APP_API_URL}/auth/refresh`,
          { refreshToken: authData.refreshToken }
        );
        
        const data = newData?.data
        console.log('refresh', data)
        
        toast.success('Refresh ba ngok')
        if (!data?.token) {
          toast.error('Pas de token dans le refresh');
        }

        authData.token = data.token;
        authData.refreshToken = data.refreshToken || authData.refreshToken;

        sessionStorage.setItem(
          authData.isAdmin ? "authAdmin" : "authUser",
          JSON.stringify(authData)
        );

        setAuthorization(data.token);
        processQueue(null, data.token);
        originalRequest.headers.Authorization = "Bearer " + data.token;

        return axios(originalRequest);

      } catch (err) {
        processQueue(err, null);
        toast.success('Session expiré, connectes toi à nouveau')
        clearAuthData();
        removeAuthorization();
        sessionStorage.clear();
        setTimeout(() => {
          logout();
        }, 2500);       
        // window.location.href = "/login";
        return Promise.reject(err);

      } finally {
        isRefreshing = false;
      }
    }

    return Promise.reject(error);
  }
);


class APIAdapter {

  get = (url, params) => {
    if (params) {
      const query = Object.keys(params)
        .map(key => `${key}=${params[key]}`)
        .join("&");
      return axios.get(`${url}?${query}`, params);
    }
    return axios.get(url);
  };

  create = (url, data) => axios.post(url, data);

  update = (url, data) => axios.patch(url, data);

  put = (url, data) => axios.put(url, data);

  post = (url, data) => axios.post(url, data);

  delete = (url, config) => axios.delete(url, { ...config });

  sendFormData = (url, formData) =>
    axios.post(url, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });

  putFormData = (url, formData) =>
    axios.put(url, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
}

const getLoggedinUser = () => {
  const user = sessionStorage.getItem("authUser");
  return user ? JSON.parse(user) : null;
};

export { APIAdapter, setAuthorization, getLoggedinUser, clearAuthData, removeAuthorization };
